export const sxStyle = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    mt: '30px',
    width: '100%',
    minHeight: '200px',
    height: '70vh',
  },

  link: {
    textDecoration: 'none',
    color: '#ffffff',
    '&:visited': {
      color: '#5e5e5e',
    },
  },

  alertContainer: {
    mx: '10px',
  },

  returnContainer: {
    mt: '20px',
  },
};
